export default __webpack_public_path__ + "static/media/Bb0.67d56a68.mp3";